import { Header, Icon, Segment } from "semantic-ui-react";

import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import Flex from "../../../../../components/Flex/Flex";
import Article from "../../../../articles/components/Article/Article";
import useArtifacts from "../../../../artifacts/hooks/useArtifacts";
import LoadingContext from "../../../../ui/components/LoadingContext/LoadingContext";
import WorkSummary from "../../../../works/components/WorkSummary/WorkSummary";

export default function SerieWork({ work, articles, channels, publisher, disableSerie }) {
	const { t } = useTranslation();

	const [artifacts, loading, error] = useArtifacts({ work });

	return (
		<LoadingContext loading={loading} error={error}>
			<Segment basic key={work.id} style={{ paddingLeft: 0, paddingRight: 0 }}>
				<Link to={`../../works/${work.id}`}>
					<Flex>
						<Header as="h3" style={{ margin: 0 }}>
							{work.serieNumber && (
								<Header.Subheader>
									{t("part")} {work.serieNumber}
								</Header.Subheader>
							)}

							{work.name}
						</Header>

						<Icon name="arrow right" color="grey" />
					</Flex>
				</Link>

				<WorkSummary work={work} publisher={publisher} disableSerie={disableSerie} />

				{articles.map((article) => {
					return (
						<Fragment key={article.id}>
							<Article
								work={work}
								article={article}
								channels={channels}
								publisher={publisher}
								artifacts={artifacts?.filter((artifact) => artifact.article?.id === article.id)}
							/>
						</Fragment>
					);
				})}
			</Segment>
		</LoadingContext>
	);
}
